module.exports = __webpack_public_path__ + "static/media/9-3.4675e8e4.mp3";